import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Ecommerce Redux States
import {
  DISABLE,
  GET, GET_ALL, GET_BY_USER, REMOVE, SAVE,UPDATE
} from "./actionTypes"
import {
  getFail,
  getSuccess,
  getAllFail,
  getAllSuccess,
  removeFail,
  removeSuccess,
  saveFail,
  saveSuccess,
  updateSuccess,
  updateFail,
  getByUserSuccess,
  getByUserFail,
  disableSuccess,
  disableFail
} from "./actions"
import { get, getAll, post, update, remove, GetByUserService, disable } from "./Service"


function* fetchAll({ payload }) {
  
  try {
    const response = yield call(getAll, payload);
    yield put(getAllSuccess(response));
  } catch (error) {
    yield put(getAllFail(error));
  }
}

function* fetchEntity({payload}) {
  try {
    const response = yield call(get,payload)
    yield put(getSuccess(response))
  } catch (error) {
    yield put(getFail(error))
  }
}

function* fetchByUser({payload}) {
  try {
    const response = yield call(GetByUserService,payload)
 
    yield put(getByUserSuccess(response))
  } catch (error) {
    const { status } = error.response;
    if(status ===404)
      yield put(getByUserFail(error.response.data))
    else
      yield put(getByUserFail(error.response.data))
  }
}

function* save(data) {
  try {
    const response = yield call(post,data.payload)
    yield put(saveSuccess(response))
  } catch (error) {
    yield put(saveFail(error))

  }
}

function* updateEntity(data) {
  try {
    const response = yield call(update,data.payload)
    yield put(updateSuccess(response))
  } catch (error) {
    yield put(updateFail(error))
  }
}


function* removeEntity({payload}) {
  try {
    const response = yield call(remove,payload)
    // yield put(fetchAll)
    yield put(removeSuccess(response))
  } catch (error) {
    yield put(removeFail(error))
  }
}

function* disableEntity({payload}) {
  try {
    const response = yield call(disable,payload)
    // yield put(fetchAll)
    yield put(disableSuccess(response))
  } catch (error) {
    yield put(disableFail(error))
  }
}

function* boxSaga() {
  yield takeEvery(REMOVE, removeEntity)
  yield takeEvery(DISABLE, disableEntity)
  yield takeEvery(GET, fetchEntity)
  yield takeEvery(GET_BY_USER, fetchByUser)
  yield takeEvery(GET_ALL, fetchAll)
  yield takeEvery(SAVE, save)
  yield takeLatest(UPDATE, updateEntity)
}

export default boxSaga
